import { Chip } from '@mui/material';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const statusColor = (status) => {
  if (status === 'affected') return { bg: 'rgba(220,38,38,0.12)', fg: '#991b1b' };
  if (status === 'fixed') return { bg: 'rgba(22,163,74,0.12)', fg: '#166534' };
  if (status === 'not_affected') return { bg: 'rgba(14,116,144,0.12)', fg: '#155e75' };
  return { bg: 'rgba(202,138,4,0.12)', fg: '#92400e' };
};

const AdminVexStatementsPage = () => {
  const columns = [
    { key: 'cve_id', label: 'CVE' },
    { key: 'package_name', label: 'Package' },
    { key: 'product', label: 'Product' },
    {
      key: 'status',
      label: 'Status',
      render: (row) => {
        const color = statusColor(row.status);
        return (
          <Chip
            size="small"
            label={(row.status || 'unknown').replace('_', ' ').toUpperCase()}
            sx={{ bgcolor: color.bg, color: color.fg, fontWeight: 600 }}
          />
        );
      }
    },
    {
      key: 'is_active',
      label: 'Active',
      render: (row) => (row.is_active ? <Chip size="small" label="Active" color="success" /> : <Chip size="small" label="Inactive" />)
    },
    {
      key: 'updated_at',
      label: 'Updated',
      render: (row) => (row.updated_at ? new Date(row.updated_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'cve_id', label: 'CVE ID', type: 'text', grid: 6 },
    { name: 'package_name', label: 'Package Name', type: 'text', grid: 6 },
    { name: 'product', label: 'Product', type: 'text', grid: 6 },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      grid: 6,
      defaultValue: 'under_investigation',
      options: [
        { value: 'under_investigation', label: 'Under Investigation' },
        { value: 'affected', label: 'Affected' },
        { value: 'not_affected', label: 'Not Affected' },
        { value: 'fixed', label: 'Fixed' }
      ]
    },
    { name: 'source', label: 'Source', type: 'text', grid: 6, defaultValue: 'manual' },
    { name: 'source_url', label: 'Source URL', type: 'text', grid: 6 },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 6, defaultValue: true },
    { name: 'valid_from', label: 'Valid From', type: 'date', grid: 6 },
    { name: 'valid_until', label: 'Valid Until', type: 'date', grid: 6 },
    { name: 'justification', label: 'Justification', type: 'multiline', grid: 12 },
    { name: 'impact_statement', label: 'Impact Statement', type: 'multiline', grid: 12 },
    { name: 'action_statement', label: 'Action Statement', type: 'multiline', grid: 12 },
    { name: 'payload', label: 'Payload (JSON)', type: 'json', grid: 12, defaultJson: {} }
  ];

  return (
    <AdminResourceCrudPage
      title="VEX Statements"
      subtitle="Manage exploitability decisions for CVEs and product/package combinations."
      icon={FactCheckOutlinedIcon}
      endpoint="/api/admin/vex-statements/"
      columns={columns}
      fields={fields}
    />
  );
};

export default AdminVexStatementsPage;
